import React from 'react'
import logo1 from '../Assets/logoNavbar.jpg'
import '../Styles/pie.css'

const piepagina = () => {
    return ( 
        <div className="pie" id="PIE">
            <a href="#INICIO" className="icon"><img src={logo1} alt=""/></a>
            
        </div>
     );
}
 
export default piepagina;